import Card from "react-bootstrap/Card";
// import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view justify-content-center">
      <Card.Body>
        <blockquote className="blockquote mb-0">
           <h2 style={{ paddingBottom: "20px", textAlign: "start" }}>
            LEARN MORE <strong className="purple">ABOUT ME</strong>
            </h2>
          <p style={{ textAlign: "start", fontSize: "18px"}}>
            Hey, I am <span className="purple" style={{ fontSize: "17px" }}>Shamim-Islam </span>
            from <span className="purple" style={{ fontSize: "15px" }}>Dhaka, Bangladesh.</span>
            <br />I am Pursuing B.Sc in Computer science and engineering
            <br />
            in PUB University of Bangladesh.
            <br />
            Apart from coding, I love to do Traveling & Explore new tecnologies.!
          </p>
          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)", textAlign: "start" }}>
           "Strive to build things that make a difference!"{" "}
          </p>
          <p style={{textAlign: "start"}}className="blockquote-footer pt-1">#Shamim</p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}


export default AboutCard;
